import React, { useState, useCallback, useEffect } from "react";
import { validatePhone } from "../../../utils/validations";
import {
  BsArrow90DegRight,
  BsArrowReturnLeft,
  BsArrowRight,
  BsEye,
  BsEyeFill,
  BsFillCalendarFill,
} from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import {
  Alert,
  Button,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { RiSurveyFill, RiSurveyLine } from "react-icons/ri";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import parse from "html-react-parser";
import ReactPlayer from "react-player";
import {
  BiCalendarAlt,
  BiCheckboxChecked,
  BiLink,
  BiLinkExternal,
  BiSolidArrowFromLeft,
} from "react-icons/bi";
import { isMobile } from "../../../utils/deviceInfo";
import { GiOpenTreasureChest } from "react-icons/gi";
import WrapLinkedRewards from "../Components/WrapLinkedRewards";
import moment from "moment";
import { AiFillClockCircle } from "react-icons/ai";
import {
  FaExternalLinkAlt,
  FaExternalLinkSquareAlt,
  FaLink,
} from "react-icons/fa";
import Toggle from "react-toggle";
import {
  applyCustomFontStyles,
  getCorrectQuestionsCount,
  isImageUrl,
  resolveTrivvyCopy,
  TEMPLATE_TYPE_MAP,
  trivvyFromCustomTemplates,
} from "../data";
import ViewSummaryCommon from "../../../components/Trivvy/ViewSummarycomon";
import { getTextFromLanguageCodeAndKey } from "../languages";
import PhoneInputWithCountrySelect from "react-phone-number-input";
export default function TriviaWelcomeBlock({
  setCurrentQuestion,
  trivvy,
  welcomeData,
  themeSettings,
  view,
  jumpToNextStep,
  uploadUrl,
  fileName,
  quizName,
  isOpenQuiz,
  updateQuizextUserEmail,
  updateQuizextUserMobile,
  updateQuizextUserFirstName,
  updateQuizextUserLastName,
  updateQuizextUserName,
  updateQuizextUserEmployeeId,
  quizExternalUserData,
  noOfQuestions,
  isMobileView,
  demoPreview,
  categoryType,
  totalQuizSeconds,
  noOfMCQs,
  currentQuizLinkedRewards,
  quizEndDate,
  endDateDue,
  startButtonLoading,
  updateQuizAnonymous,
  quizSubmitAnonymous,
  showAnonymousToggle,
  timedQuestionsEnable,
  minimumPassingPercent,
  userIdentificationOptions,
  uploadText,
  templateType,
  customTemplateData,
  triviaGenerationType,
  holidayTemplateName,
  isMixedTimedMcqTrivvy,
  librarySummaryText,
  trivvyLanguage,
  isMessaging
}) {
  const isMobile = isMobileView;
  const isSurvey = categoryType === "SURVEY" && !isMessaging;
  const [customDataModal, setCustomDataModal] = useState(null);
  const [btnErrorMessage, setBtnErrorMessage] = useState("");
  const [letsDoItClicked, setLetsDoItClicked] = useState(false);

  useEffect(() => {
    if (!startButtonLoading && letsDoItClicked) {
      setLetsDoItClicked(false);
    }
  }, [startButtonLoading]);

  const isInputValid = () => {
    if (!isOpenQuiz) return true;
    if (
      inputType == "EMAIL" &&
      quizExternalUserData && quizExternalUserData.email && validateEmail(quizExternalUserData.email)
    ) {
      return true;
    }
    if (
      inputType == "EMPLOYEE_ID" &&
      quizExternalUserData && quizExternalUserData.employeeId && quizExternalUserData.employeeId.length
    ) {
      return true;
    }
    if (
      inputType == "NAME" &&
      quizExternalUserData && quizExternalUserData.name && quizExternalUserData.name.length > 2
    ) {
      return true;
    }
    if (
      inputType == "FIRST_LAST_NAME" &&
      quizExternalUserData &&
      quizExternalUserData.firstName && quizExternalUserData.firstName.length > 2 &&
      quizExternalUserData.lastName && quizExternalUserData.lastName.length > 2
    ) {
      return true;
    }
    if (inputType == "ANONYMOUS") {
      return true;
    }
    if (
      inputType == "MOBILE_NUMBER" &&
      quizExternalUserData && quizExternalUserData.mobileNumber && validatePhone(quizExternalUserData.mobileNumber)
    ) {
      return true;
    }
    // Fallback: if the anonymous toggle is available AND the user has turned it ON
    // (quizSubmitAnonymous === false means "submit anonymously"; see Toggle
    // checked={!quizSubmitAnonymous} below), the identification field is not
    // required, so the button stays enabled. Otherwise the field must be filled.
    if (!quizSubmitAnonymous && showAnonymousToggle) {
      return true;
    }
    return false;
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const buttonDisable = () => {
    if (isOpenQuiz) {
      if (
        inputType == "EMAIL" &&
        quizExternalUserData &&
        quizExternalUserData.email &&
        validateEmail(quizExternalUserData.email)
      ) {
        setBtnErrorMessage("");
        return false;
      } else if (
        inputType == "EMPLOYEE_ID" &&
        quizExternalUserData &&
        quizExternalUserData.employeeId &&
        quizExternalUserData.employeeId.length
      ) {
        setBtnErrorMessage("");
        return false;
      } else if (
        inputType == "NAME" &&
        quizExternalUserData &&
        quizExternalUserData.name &&
        quizExternalUserData.name.length > 2
      ) {
        setBtnErrorMessage("");
        return false;
      } else if (
        inputType == "FIRST_LAST_NAME" &&
        quizExternalUserData &&
        (quizExternalUserData.firstName || quizExternalUserData.lastName) &&
        ((quizExternalUserData.firstName &&  quizExternalUserData.firstName.length > 2) || (quizExternalUserData.lastName &&  quizExternalUserData.lastName.length > 2)) 
        
      ) {
        setBtnErrorMessage("");
        return false;
      } else if (
        inputType == "ANONYMOUS"
      ) {
        setBtnErrorMessage("");
        return false;
      } else if (
        inputType == "MOBILE_NUMBER" &&
        quizExternalUserData &&
        quizExternalUserData.mobileNumber &&
        quizExternalUserData.mobileNumber.length > 6
      ) {
        setBtnErrorMessage("");
        return false;
      } else if(!quizSubmitAnonymous && showAnonymousToggle) {
        // Stays in sync with isInputValid() fallback above: only allow the click
        // through when the user has explicitly turned ON the anonymous toggle.
        return false;
      } else {
        setBtnErrorMessage(
          inputType === "EMAIL"
            ? getTextFromLanguageCodeAndKey(trivvyLanguage, "emailIsRequired")
            : inputType === "EMPLOYEE_ID"
            ? getTextFromLanguageCodeAndKey(trivvyLanguage, "employeeIdRequired")
            : inputType === "FIRST_LAST_NAME"
            ? getTextFromLanguageCodeAndKey(trivvyLanguage, "firstNameAndLastNameRequired")
            : inputType === "MOBILE_NUMBER"
            ? getTextFromLanguageCodeAndKey(trivvyLanguage, "mobileNumberIsRequired")
            : ""
        );
        return true;
      }
    } else {
      return false;
    }
  };

  const isNonKcTrivvy = (trivvy) => {
    return (
      trivvy.questions &&
      trivvy.questions.filter((question) => question.correct_options.length == 0).length > 0
    )
  }

  const handleEnterPress = (event) => {
    if (!isOpenQuiz && event.key === "Enter") {
      jumpToNextStep(0);
    }
  };

  const headingValue =
    welcomeData && welcomeData.heading
      ? welcomeData.heading.indexOf("One thing before you go") > -1
        ? ""
        : welcomeData.heading
      : "";
  // const headingValue = welcomeData && welcomeData.heading

  const inputType = userIdentificationOptions[0];

  if (totalQuizSeconds == 0) {
    totalQuizSeconds = getTextFromLanguageCodeAndKey(
      trivvyLanguage,
      "notTimed"
    );
  }
  // else if (totalQuizSeconds == "MCQ_MIXED") {
  //   totalQuizSeconds = "Multiple Choice Questions are timed";
  // }
  else {
    if (isMixedTimedMcqTrivvy) {
      totalQuizSeconds = getTextFromLanguageCodeAndKey(
        trivvyLanguage,
        "mcqsAreTimed"
      );
    } else {
      totalQuizSeconds = `${getTextFromLanguageCodeAndKey(
        trivvyLanguage,
        "takes"
      )} ${totalQuizSeconds} ${getTextFromLanguageCodeAndKey(
        trivvyLanguage,
        "seconds"
      )}`;
    }
  }

  return (
    <Row
      className={
        isOpenQuiz
          ? "SurveyWelcomeBlock_fullHeight_62 px-0 mx-0"
          : `SurveyWelcomeBlock_fullHeight px-0 mx-0 ${
              isMobile ? "SurveyWelcomeBlock_fullHeight_62_mob" : "h100-62"
            } `
      }
      style={{
        ...(isMobile && {
          overflowY: "auto",
          overflowX: "hidden",
        }),
        ...applyCustomFontStyles(themeSettings),
      }}
    >
      <Col
        sm={isMobile ? 12 : 6}
        className={
          isMobile ? "px-0" : demoPreview ? "demoPreview_scroll_left" : ""
        }
        style={{}}
      >
        {isMobile && (
          <div style={{}}>
            {welcomeData.media_url ? (
              <div className="trivia-assets welcome-media">
                {welcomeData.media_type &&
                welcomeData.media_type.indexOf("video") > -1 ? (
                  <ReactPlayer
                    // height={"450px"}
                    width="100%"
                    playing={true}
                    playsinline
                    controls={true}
                    muted={true}
                    loop={true}
                    url={welcomeData.media_url}
                    style={{
                      backgroundColor: "black",
                    }}
                  />
                ) : (
                  <div>
                    <img
                      className="full-wc p-0"
                      src={welcomeData.media_url}
                      width="100%"
                      style={{
                        // height: "450px",
                        ...(demoPreview &&
                          isMobile && {
                            minHeight: "250px",
                            maxHeight: "250px",
                          }),
                      }}
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        )}

        <div
          className={
            !isMobile
              ? "trivia-survey-edit-questions-ui_centerUI"
              : "trivia-survey-edit-questions-ui_centerUI_mobile p-2"
          }
          style={{
            alignItems: "flex-start",
            flexDirection: "column",
          }}
          tabIndex={0}
          onKeyDown={handleEnterPress}
        >
          {/* {categoryType && categoryType=='REWARD'?
          <span className="reward-trivvy-txt-welcome"> <GiOpenTreasureChest size={18}/> Reward Trivvy</span>:null} */}

          <div
            className={
              !isMobile
                ? "trivia-survey-edit-questions-ui_centerUI_contents"
                : ""
            }
            style={{
              // flex: 1,
              display: "flex",
              width: isMobile ? "100%" : "90%",
              flexDirection: "column",
              paddingInline: isMobile ? "40px" : 0,
              // wordBreak: "break-all",
            }}
          >
            <div
              style={{
                width: "100%",
                // minHeight: isMobile ? "10%" : "15%",
                fontSize: isMobile ? (demoPreview ? "30px" : "30px") : "50px",

                marginTop: isMobile ? "10px" : "0px",
                display: "block",
                // maxHeight: "30%",
                // overflowY: "auto",
              }}
              className="trivia-survey-edit-questions-ui_question_title rich-title-tight"
            >
              {parse(quizName || "")}
            </div>


           

            <div style={{ height: "100%", width: "100%" }}>
              {headingValue ? (
                <div className="trivia-survey-edit-questions-ui_question_title">
                  <span
                    className={
                      isMobile
                        ? "edit_survey_question_wrapper_noborder_mobile"
                        : "edit_survey_question_wrapper_noborder text-left"
                    }
                    style={{
                      width: "100%",
                      fontSize: isMobile ? "18px" : "22px",
                    }}
                  >
                    {parse(headingValue || "<p></p>")}
                  </span>
                </div>
              ) : (
                ""
              )}

{isMobile &&
                showAnonymousToggle &&
                !(inputType == "ANONYMOUS") ? (
                  <div className="flex items-center welcomeBlockAnonymously mt-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-1" viewBox="0 0 16 16" className="anonymousIcon">
                        <path fill-rule="evenodd" d="m4.736 1.968-.892 3.269-.014.058C2.113 5.568 1 6.006 1 6.5 1 7.328 4.134 8 8 8s7-.672 7-1.5c0-.494-1.113-.932-2.83-1.205l-.014-.058-.892-3.27c-.146-.533-.698-.849-1.239-.734C9.411 1.363 8.62 1.5 8 1.5s-1.411-.136-2.025-.267c-.541-.115-1.093.2-1.239.735m.015 3.867a.25.25 0 0 1 .274-.224c.9.092 1.91.143 2.975.143a30 30 0 0 0 2.975-.143.25.25 0 0 1 .05.498c-.918.093-1.944.145-3.025.145s-2.107-.052-3.025-.145a.25.25 0 0 1-.224-.274M3.5 10h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5m-1.5.5q.001-.264.085-.5H2a.5.5 0 0 1 0-1h3.5a1.5 1.5 0 0 1 1.488 1.312 3.5 3.5 0 0 1 2.024 0A1.5 1.5 0 0 1 10.5 9H14a.5.5 0 0 1 0 1h-.085q.084.236.085.5v1a2.5 2.5 0 0 1-5 0v-.14l-.21-.07a2.5 2.5 0 0 0-1.58 0l-.21.07v.14a2.5 2.5 0 0 1-5 0zm8.5-.5h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5"/>
                     </svg> {" "}
                    {getTextFromLanguageCodeAndKey(
                      trivvyLanguage,
                      "submitAnonymously"
                    )}
                    <Toggle
                        checked={!quizSubmitAnonymous}
                      onChange={(e) => {
                        updateQuizAnonymous(e.target.checked);
                      }}
                      icons={false}
                      size={15}
                      style={{
                        marginLeft:'5px'
                      }}
                    />
                    <span
                      className="ml-2"
                      // style={{ verticalAlign: "text-bottom" }}
                    >
                     
                    
                      {/* {getTextFromLanguageCodeAndKey(
                        trivvyLanguage,
                        "submitAnonymously"
                      )} */}
                    </span>
                  </div>
                ) : (
                  ""
                )}

            {!isMobile && showAnonymousToggle && !(inputType == "ANONYMOUS") ? (
                      <div className="flex items-center welcomeBlockAnonymously mt-5">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-1" viewBox="0 0 16 16" className="anonymousIcon">
                          <path fill-rule="evenodd" d="m4.736 1.968-.892 3.269-.014.058C2.113 5.568 1 6.006 1 6.5 1 7.328 4.134 8 8 8s7-.672 7-1.5c0-.494-1.113-.932-2.83-1.205l-.014-.058-.892-3.27c-.146-.533-.698-.849-1.239-.734C9.411 1.363 8.62 1.5 8 1.5s-1.411-.136-2.025-.267c-.541-.115-1.093.2-1.239.735m.015 3.867a.25.25 0 0 1 .274-.224c.9.092 1.91.143 2.975.143a30 30 0 0 0 2.975-.143.25.25 0 0 1 .05.498c-.918.093-1.944.145-3.025.145s-2.107-.052-3.025-.145a.25.25 0 0 1-.224-.274M3.5 10h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5m-1.5.5q.001-.264.085-.5H2a.5.5 0 0 1 0-1h3.5a1.5 1.5 0 0 1 1.488 1.312 3.5 3.5 0 0 1 2.024 0A1.5 1.5 0 0 1 10.5 9H14a.5.5 0 0 1 0 1h-.085q.084.236.085.5v1a2.5 2.5 0 0 1-5 0v-.14l-.21-.07a2.5 2.5 0 0 0-1.58 0l-.21.07v.14a2.5 2.5 0 0 1-5 0zm8.5-.5h2a.5.5 0 0 1 .5.5v1a1.5 1.5 0 0 1-3 0v-1a.5.5 0 0 1 .5-.5"/>
                        </svg>  {" "}
                          {getTextFromLanguageCodeAndKey(
                            trivvyLanguage,
                            "submitAnonymously"
                          )}

                          <Toggle
                          // checked={quizSubmitAnonymous==true?false:true}
                          checked={!quizSubmitAnonymous}
                          onChange={(e) => {
                            updateQuizAnonymous(e.target.checked);
                          }}
                          icons={false}
                          size={15}
                          style={{
                            marginLeft:'5px'
                          }}
                        />
                        <span
                          className="ml-2"
                          style={{ verticalAlign: "text-bottom" }}
                        >
                        
                          {/* {getTextFromLanguageCodeAndKey(
                            trivvyLanguage,
                            "submitAnonymously"
                          )} */}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}

              <div
                className={
                  isOpenQuiz
                    ? "mt-1"
                    : "mt-0 trivia-survey-start-page-details-container"
                }
                style={{
                  lineHeight:"2.5em" 
                }}
              >
                {isOpenQuiz && !endDateDue && !(!quizSubmitAnonymous && showAnonymousToggle) ? (
                  <div 
                  // className={`mb-3 `}
                  className={`mb-3 d-flex gap-3`}
                  style={{
                    gap:'1em'
                  }}
                  // style={{
                  //   display: inputType === "FIRST_LAST_NAME"?"flex":"",
                  //   gap: inputType === "FIRST_LAST_NAME"?"1rem":""
                  // }}
                  >
                    { !quizSubmitAnonymous && showAnonymousToggle? (
                            null
                    ) :
                    inputType == "EMPLOYEE_ID" ? (
                      <div className="floating-label-group flex-grow-1 w-100 mt-2 flex-fill mb-0">
                        <input
                          type="text"
                          id="eid"
                          className="form-control"
                          onChange={(e) => {
                            updateQuizextUserEmployeeId(e.target.value);
                          }}
                          value={
                            quizExternalUserData &&
                            quizExternalUserData.employeeId
                          }
                          placeholder=" "
                          autoComplete="off"
                          style={{
                            background: "transparent",
                          }}
                        />
                        <label
                          className="floating-label"
                          style={{
                            background: "transparent",
                          }}
                        >
                          {!quizSubmitAnonymous && showAnonymousToggle? (
                            null
                          ) 
                          :quizSubmitAnonymous && showAnonymousToggle? (
                            <span className="text-info">
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "employeeId"
                              )}
                              *
                            </span>
                          )
                          : !quizExternalUserData ? (
                            <span className="text-danger">
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "employeeIdRequired"
                              )}
                              *
                            </span>
                          ) : quizExternalUserData &&
                            quizExternalUserData.employeeId ? (
                            <span className="text-success">
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "employeeId"
                              )}{" "}
                              <BiCheckboxChecked />
                            </span>
                          ) : (
                            <span className="text-danger">
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "enterEmployeeId"
                              )}
                            </span>
                          )}
                        </label>
                      </div>
                    ) : inputType == "EMAIL" ? (
                      <div className="floating-label-group flex-grow-1 w-100 mt-2 flex-fill mb-0">
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          onChange={(e) => {
                            updateQuizextUserEmail(e.target.value);
                          }}
                          value={
                            quizExternalUserData && quizExternalUserData.email
                          }
                          placeholder=" "
                          autoComplete="off"
                          style={{
                            background: "transparent",
                          }}
                        />
                        <label
                          className="floating-label"
                          style={{
                            background: "transparent",
                          }}
                        >
                          {" "}
                          { !quizSubmitAnonymous && showAnonymousToggle? (
                            null
                          ) :
                          quizSubmitAnonymous || showAnonymousToggle? (
                            <span className="text-info">
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "email"
                              )}
                              *
                            </span>
                          ) : !quizExternalUserData ? (
                            <span className="text-danger">
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "emailIsRequired"
                              )}
                              *
                            </span>
                          ) : quizExternalUserData &&
                            quizExternalUserData.email &&
                            validateEmail(quizExternalUserData.email) ? (
                            <span className="text-success">
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "email"
                              )}{" "}
                              <BiCheckboxChecked />
                            </span>
                          ) : (
                            <span className="text-danger">
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "enterEmail"
                              )}
                            </span>
                          )}{" "}
                        </label>
                      </div>
                    ) : inputType === "FIRST_LAST_NAME" ? (
                      <>
                        <div className="floating-label-group flex-grow-1 w-100 mt-2 flex-fill mb-0" 
                        // style={{
                        //   flex:"0 0 50%",
                        //   maxWidth:"50%",
                        //   minWidth:"0"
                        // }}
                        >
                          <input
                            type="text"
                            id="name"
                            className="form-control"
                            onChange={(e) => {
                              updateQuizextUserFirstName(e.target.value);
                            }}
                            value={
                              quizExternalUserData &&
                              quizExternalUserData.firstName
                            }
                            placeholder=" "
                            autoComplete="off"
                            style={{
                              width:'100%',
                              background: "transparent",
                            }}
                          />
                          <label
                            className="floating-label"
                            style={{
                              background: "transparent",
                            }}
                          >
                            {" "}
                            {!quizSubmitAnonymous && showAnonymousToggle? (
                            null
                          ) :quizSubmitAnonymous || showAnonymousToggle? (
                              <span className="text-info">
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "firstName"
                                )}
                                *
                              </span>
                            ) : !quizExternalUserData ? (
                              <span className="text-danger">
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "firstNameIsRequired"
                                )}
                                *
                              </span>
                            ) : quizExternalUserData &&
                              quizExternalUserData.firstName &&
                              quizExternalUserData.firstName.length > 3 ? (
                              <span className="text-success">
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "firstName"
                                )}{" "}
                                <BiCheckboxChecked />
                              </span>
                            ) : (
                              <span className="text-danger">
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "enterFirstName"
                                )}
                              </span>
                            )}{" "}
                          </label>
                        </div>
                        <div className="floating-label-group flex-grow-1 w-100 mt-2 flex-fill mb-0"
                        // style={{
                        //   flex:"0 0 50%",
                        //   maxWidth:"50%",
                        //   minWidth:"0"
                        // }}
                        >
                          <input
                            type="text"
                            id="name"
                            className="form-control"
                            onChange={(e) => {
                              updateQuizextUserLastName(e.target.value);
                            }}
                            value={
                              quizExternalUserData &&
                              quizExternalUserData.lastName
                            }
                            placeholder=" "
                            autoComplete="off"
                            style={{
                              width:'100%',
                              background: "transparent",
                            }}
                          />
                          <label
                            className="floating-label"
                            style={{
                              background: "transparent",
                            }}
                          >
                            {" "}
                            {!quizSubmitAnonymous && showAnonymousToggle? (
                            null
                          ) :quizSubmitAnonymous || showAnonymousToggle? (
                              <span className="text-info">
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "lastName"
                                )}
                                *
                              </span>
                            ) : !quizExternalUserData ? (
                              <span className="text-danger">
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "lastNameIsRequired"
                                )}
                                *
                              </span>
                            ) : quizExternalUserData &&
                              quizExternalUserData.lastName &&
                              quizExternalUserData.lastName.length > 3 ? (
                              <span className="text-success">
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "lastName"
                                )}{" "}
                                <BiCheckboxChecked />
                              </span>
                            ) : (
                              <span className="text-danger">
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "enterLastName"
                                )}
                              </span>
                            )}{" "}
                          </label>
                        </div>
                      </>
                    ) : inputType === "MOBILE_NUMBER" ? (
                      <div className="floating-label-group flex-grow-1 w-100 mt-2 flex-fill mb-0 mobile-input-wrapper">
                        <PhoneInputWithCountrySelect
                          placeholder={getTextFromLanguageCodeAndKey(
                            trivvyLanguage,
                            quizSubmitAnonymous
                              ? "mobile"
                              : "mobileNumberIsRequired"
                          )}
                          value={
                            (quizExternalUserData &&
                              quizExternalUserData.mobileNumber) ||
                            ""
                          }
                          onChange={(v) => {
                            updateQuizextUserMobile(v);
                          }}
                          defaultCountry="US"
                          className="p-0"
                          style={{
                            width: "100%",
                            background: "transparent",
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}

                {btnErrorMessage ? (
                  <Alert color="danger" className="py-1">
                    {" "}
                    {btnErrorMessage}{" "}
                  </Alert>
                ) : (
                  ""
                )}

                {quizEndDate ? (
                  <div className="my-1">
                    <BsFillCalendarFill />{" "}
                    {getTextFromLanguageCodeAndKey(trivvyLanguage, "endDate")} -{" "}
                    {moment(quizEndDate).format("MM/DD/YYYY")}
                  </div>
                ) : (
                  ""
                )}

                <div
                  className="my-1"
                  // className="TriviaEditViewListUI_leftContainer_leftContainer_component"
                  style={
                    {
                      // position: demoPreview ? "relative" : "absolute",
                      // bottom: isMobile ? "none" : "20px",
                      // width: isMobile ? "auto" : "60%",
                      // marginRight: isMobile ? "auto" : "10%",
                      // backgroundColor:themeSettings.quizBackgroundColor,
                      // color:themeSettings.quizTextColor
                    }
                  }
                >
                  {currentQuizLinkedRewards &&
                  currentQuizLinkedRewards.length ? (
                    <div
                      style={{
                        wordBreak: "break-all",
                      }}
                      className="my-0"
                    >
                      {getTextFromLanguageCodeAndKey(
                        trivvyLanguage,
                        "rewardText"
                      )}
                      <WrapLinkedRewards
                        quizPage={demoPreview ? false : true}
                        rewards={currentQuizLinkedRewards}
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  <div
                    // className="TriviaEditViewListUI_leftContainer_uploadedURL"
                    style={{}}
                  >
                    {triviaGenerationType != 2 && !isNonKcTrivvy(trivvy) && (
                      <div
                      // style={{
                      //   wordBreak: "break-all",
                      // }}
                      >
                        {" "}
                        <FaLink />{" "}
                        {getTextFromLanguageCodeAndKey(
                          trivvyLanguage,
                          "generatedOn"
                        )}{" "}
                        {holidayTemplateName ? (
                          <b>{holidayTemplateName}</b>
                        ) : uploadUrl ? (
                          <a
                            href="#"
                            onClick={function(e) {
                              e.preventDefault();
                              var triviaId = trivvy && trivvy._id;
                              if (triviaId) {
                                axios.get(url.publicGetSignedUrl, {
                                  params: { id: triviaId, model: 'TriviaTemplate', inline: 1 }
                                }).then(function(res) {
                                  var signedUrl = res.data && res.data.url;
                                  if (signedUrl) {
                                    window.open(signedUrl, '_blank');
                                  } else {
                                    window.open(uploadUrl, '_blank');
                                  }
                                }).catch(function() {
                                  window.open(uploadUrl, '_blank');
                                });
                              } else {
                                window.open(uploadUrl, '_blank');
                              }
                            }}
                            style={{ cursor: 'pointer' }}
                          >
                            link
                          </a>
                        ) : uploadText && uploadText.length ? (
                          <span
                            className="cursor-pointer"
                            onClick={() => setCustomDataModal(uploadText)}
                          >
                            <b className="text-info">
                              {" "}
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "customText"
                              )}
                            </b>{" "}
                            {!isMobile && (
                              <small>
                                (
                                {getTextFromLanguageCodeAndKey(
                                  trivvyLanguage,
                                  "clickToSeeText"
                                )}
                                )
                              </small>
                            )}
                          </span>
                        ) : templateType &&
                          trivvyFromCustomTemplates({ templateType }) &&
                          customTemplateData ? (
                          <span
                            className="cursor-pointer"
                            style={{
                              ...(isMobile && {
                                fontSize: "15px",
                                whiteSpace: "no-wrap",
                              }),
                            }}
                          >
                            <b
                              className="text-info"
                              onClick={() => {
                                const html = (
                                  <ul>
                                    {customTemplateData.industry ? (
                                      <li>
                                        {" "}
                                        <b> Industry: </b>
                                        {customTemplateData.industry}
                                      </li>
                                    ) : (
                                      ""
                                    )}
                                    {customTemplateData.jobCategory ? (
                                      <li>
                                        <b>Job category: </b>{" "}
                                        {customTemplateData.jobCategory}
                                      </li>
                                    ) : (
                                      ""
                                    )}
                                    {customTemplateData.occupation ? (
                                      <li>
                                        {" "}
                                        <b>Occupation: </b>{" "}
                                        {customTemplateData.occupation}
                                      </li>
                                    ) : (
                                      ""
                                    )}
                                    {customTemplateData.workFlexibility ? (
                                      <li>
                                        <b>Work flexibility: </b>
                                        {customTemplateData.workFlexibility}
                                      </li>
                                    ) : (
                                      ""
                                    )}
                                  </ul>
                                );
                                setCustomDataModal(html);
                              }}
                            >
                              {TEMPLATE_TYPE_MAP[templateType]}
                            </b>
                            {!isMobile && <small> (view)</small>}
                          </span>
                        ) : (
                          ""
                        )}
                        {customDataModal && (
                          <Modal isOpen={true}>
                            <ModalHeader
                              className="trivia_modal_header_bg"
                              toggle={() => setCustomDataModal(null)}
                            >
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "customData"
                              )}
                            </ModalHeader>
                            <ModalBody className="p-3">
                              {customDataModal}
                            </ModalBody>
                          </Modal>
                        )}
                      </div>
                    )}

                    {!isMessaging&&<div className="trivia-view-leftCotainer-timer">
                      <div className="my-0">
                        <span>
                          {" "}
                          <RiSurveyFill />{" "}
                          {getTextFromLanguageCodeAndKey(
                            trivvyLanguage,
                            "questions"
                          )}
                        </span>
                        : {noOfQuestions}
                      </div>
                    </div>}

                    {!isMessaging&&
                      <div className="my-0">
                        {timedQuestionsEnable && !isSurvey ? (
                          <div
                            style={{
                              color: themeSettings.quizTextColor,
                              // fontSize: "16px",
                            }}
                            className="mb-2"
                          >
                            <AiFillClockCircle className="mr-1" />
                            {totalQuizSeconds}
                          </div>
                        ) : (
                          <></>
                          // <div
                          //   style={{
                          //     color: themeSettings.quizTextColor,
                          //     fontSize: "16px",
                          //   }}
                          //   className="mb-2"
                          // >
                          //   <AiFillClockCircle className="mr-1" />
                          //   {getTextFromLanguageCodeAndKey(
                          //     trivvyLanguage,
                          //     "notTimed"
                          //   )} 
                          // </div>
                        )}
                      </div>
                    }

                    {librarySummaryText ? (
                      <div className="my-0">
                        {" "}
                        <ViewSummaryCommon
                          summaryText={librarySummaryText}
                          btnUi={
                            <span className="view-summary-styles">
                              {" "}
                              <BsEyeFill className="mr-1" />{" "}
                              {getTextFromLanguageCodeAndKey(
                                trivvyLanguage,
                                "viewSummary"
                              )}
                            </span>
                          }
                        />{" "}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

      

                {isMobile && minimumPassingPercent > 0 ? (
                  <div className="mt-3">
                    {getTextFromLanguageCodeAndKey(
                      trivvyLanguage,
                      "percentToPass"
                    )}
                    : {minimumPassingPercent}% or{" "}
                    {getCorrectQuestionsCount(noOfMCQs, minimumPassingPercent)}{" "}
                    {getTextFromLanguageCodeAndKey(trivvyLanguage, "of")}{" "}
                    {noOfMCQs}{" "}
                    {getTextFromLanguageCodeAndKey(trivvyLanguage, "correct")}.
                  </div>
                ) : null}

                {!isMobile && (
                  <div className="mt-2 mb-5">
                    

                    {minimumPassingPercent > 0 ? (
                      <div className="mt-3">
                        {getTextFromLanguageCodeAndKey(
                          trivvyLanguage,
                          "percentToPass"
                        )}
                        : {minimumPassingPercent}% or{" "}
                        {getCorrectQuestionsCount(
                          noOfMCQs,
                          minimumPassingPercent
                        )}{" "}
                        {getTextFromLanguageCodeAndKey(trivvyLanguage, "of")}{" "}
                        {noOfMCQs}{" "}
                        {getTextFromLanguageCodeAndKey(
                          trivvyLanguage,
                          "correct"
                        )}
                        .
                      </div>
                    ) : null}


{/* Lets Do it button */}
                    {!endDateDue && (
                      <Button
                        // className="trivia-action-button-media px-3 py-2"
                        disabled={startButtonLoading || letsDoItClicked || !isInputValid()}
                        onClick={() =>{
                          if(isMessaging){

                            if (buttonDisable() == true || letsDoItClicked) return null;
                            setLetsDoItClicked(true);
                            return setCurrentQuestion("MESSAGING");
                          }else{
                               if (buttonDisable() == true || startButtonLoading) return null;
                               setLetsDoItClicked(true);
                               return jumpToNextStep(0);

                          }


                        }}
                        style={{
                          // cursor:
                          width: "max-content",
                          height: "auto",
                          color: welcomeData.startButtonSettings
                            ? welcomeData.startButtonSettings.color
                            : "rgb(255, 69, 0)",
                          borderColor: welcomeData.startButtonSettings
                            ? welcomeData.startButtonSettings.color
                            : "rgb(255, 69, 0)",
                          backgroundColor: welcomeData.startButtonSettings
                            ? welcomeData.startButtonSettings.backgroundColor
                            : "rgb(255, 255, 255)",
                        }}
                        color="success"
                        className="mt-3 trivvy-start-btn-styles trivia_ip_btn"
                      >
                        {startButtonLoading
                          ? "Loading..."
                          : resolveTrivvyCopy(
                              welcomeData.buttonText,
                              "letsDoIt",
                              trivvyLanguage
                            )}
                      </Button>
                    )}
                  </div>
                )}

                {!isMobile && endDateDue && quizEndDate ? (
                  <Alert
                    style={{ width: isMobile ? "100%" : "max-content" }}
                    color="danger"
                    className="my-2"
                  >
                    {getTextFromLanguageCodeAndKey(
                      trivvyLanguage,
                      "trivvyEnded"
                    )}
                    {moment(quizEndDate).format("MM/DD/YYYY")}{" "}
                  </Alert>
                ) : (
                  ""
                )}

                {/* {!isOpenQuiz && (
                  <span className="ml-2">
                    <b>Press Enter </b>{" "}
                    <BsArrowReturnLeft size="14px" className="ml-2" />
                  </span>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </Col>

      {!isMobile ? (
        <Col sm={6} 
        className="pr-0"
        style={{overflow:'hidden'}}
        >
          {isImageUrl(welcomeData) ? (
            <div
              className="trivvy_wc__bg_image_blur"
              style={{
                backgroundImage: `url(${welcomeData.media_url})`,
              }}
            ></div>
          ) : (
            ""
          )}

          <div>
            {welcomeData.media_url ? (
              <div className="trivia-assets">
                {welcomeData.media_type &&
                welcomeData.media_type.indexOf("video") > -1 ? (
                  <ReactPlayer
                    className=""
                    height={
                      demoPreview
                        ? "550px"
                        : isOpenQuiz
                        ? "100vh"
                        : "calc(100vh - 62px)"
                    }
                    width="100%"
                    playing={true}
                    playsinline
                    controls={true}
                    muted={true}
                    loop={true}
                    url={welcomeData.media_url}
                    style={{
                      backgroundColor: "black",

                      // marginLeft: "6%",
                      // marginRight: "6%",
                      // marginTop: demoPreview ? "16%" : "12%",
                      // marginBottom: "8%",
                      // position: "absolute",
                    }}
                  />
                ) : (
                  <div>
                    <img
                      className="full-wc"
                      src={welcomeData.media_url}
                      width="100%"
                      style={{
                        position: "absolute",
                        // padding: "25% 0",
                      }}
                    />
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </Col>
      ) : (
        ""
      )}

      {isMobile && !demoPreview && (
        <div
          className="text-center"
          style={{
            position: demoPreview ? "relative" : "fixed",
            bottom: isOpenQuiz ? "0px" : "0px",
            backgroundColor: themeSettings.quizBackgroundColor,
            width: "100%",
            zIndex: 9999999,
          }}
        >
          <div
            style={{
              paddingBottom: "10px",
              paddingTop: "10px",
              width: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.07)",
            }}
          >
            {endDateDue && quizEndDate ? (
              <Alert
                style={{ width: isMobile ? "100%" : "max-content" }}
                color="danger"
                className="my-2"
              >
                {getTextFromLanguageCodeAndKey(trivvyLanguage, "trivvyEnded")}
                {moment(quizEndDate).format("MM/DD/YYYY")}{" "}
              </Alert>
            ) : (
              ""
            )}

 {/* Lets do it  */}
            {!endDateDue && (
              <Button
                // className="trivia-action-button-media px-3 py-2"
                disabled={startButtonLoading || letsDoItClicked || !isInputValid()}
                onClick={() => {
                  if (buttonDisable() == true || startButtonLoading || letsDoItClicked) return null;
                  setLetsDoItClicked(true);
                  return jumpToNextStep(0);
                }}
                style={{
                  cursor: "pointer",
                  width: "90%",
                  color: welcomeData.startButtonSettings
                    ? welcomeData.startButtonSettings.color
                    : "rgb(255, 69, 0)",
                  borderColor: welcomeData.startButtonSettings
                    ? welcomeData.startButtonSettings.color
                    : "rgb(255, 69, 0)",
                  backgroundColor: welcomeData.startButtonSettings
                    ? welcomeData.startButtonSettings.backgroundColor
                    : "rgb(255, 255, 255)",
                }}
                color="success"
                className="mt-2 trivia_ip_btn trivvy-start-btn-styles"
              >
                {startButtonLoading
                  ? "Loading..."
                  : resolveTrivvyCopy(
                      welcomeData.buttonText,
                      "letsDoIt",
                      trivvyLanguage
                    )}
              </Button>
            )}
          </div>
        </div>
      )}
    </Row>
  );
}
